import React from 'react';
import { Link } from 'react-router-dom';
import MaterialTable, { MTableToolbar } from 'material-table';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import {intersperse} from "../units/UnitTable";

const OtherLeaseTable = ({ data, history }) => {
  const editableData = data.map((record) => {
    const copy = { ...record };
    copy.lands =
      copy.locatedOn.length === 0
        ? <span style={{ color: 'red' }}>Error No Connection To Tract</span>
        : <div dangerouslySetInnerHTML={{ __html: copy.locatedOn.map((r) => r.name).join('<br />') }} />;
    return copy;
  });

  const columns = [
      // Hiding Lease Name for now. Lessee is set directly in create and association is made after OtherLease creation / updated anytime lessee is updated.
      // projectName is now going to be the same / kept in sync with the Lessee value, other logic across application still uses it.
    // {
    //   title: 'Lease Name',
    //   field: 'projectName',
    //   defaultSort: 'asc',
    //   render: (rowData) => (
    //     <Link
    //       to={`/OtherLeases/${rowData.id}?name=${encodeURIComponent(rowData.projectName)}`}
    //           target='_blank'>
    //       {rowData.projectName === ' ' ? 'None' : rowData.projectName}
    //     </Link>
    //   ),
    // },
    {
      title: 'LESSEE',
      field: 'lessee',
      render: (rowData) => (
          <Link
              to={`/OtherLeases/${rowData.id}?name=${encodeURIComponent(rowData.projectName)}`}
              target='_blank'>
            {rowData.projectName === ' ' ? 'None' : rowData.lessee}
          </Link>
      ),
    },
    {
      title: 'Land ID',
      field: 'lands',
    },
    {
      title: 'DATE OF LEASE',
      field: 'dateOfLease',
      render: (rowData) =>
        moment(rowData.dateOfLease).isValid() ? moment(rowData.dateOfLease).format('MM/DD/YYYY') : rowData.dateOfLease,
    },
    {
      title: 'RENEWAL DATE',
      field: 'dateOfExpiration',
      render: (rowData) =>
        moment(rowData.dateOfExpiration).isValid()
          ? moment(rowData.dateOfExpiration).format('MM/DD/YYYY')
          : rowData.dateOfExpiration,
    },
    {
      title: 'TYPE OF LEASE',
      field: 'type',
    },
    {
      title: 'STATUS',
      field: 'status',
    },
  ];

  return (
    <div>
    <MaterialTable
      columns={columns}
      data={editableData}
      components={{
        Toolbar: (props) => (
          <div
            style={{
              backgroundColor: '#1976d2',
              // marginLeft: -24,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '0 25px 0 25px',
            }}
          >
            <MTableToolbar {...props} />
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => history.push('/AddOtherLease')}
              style={{
                fontSize: '0.75rem',
                minWidth: 'auto',
                padding: '4px 10px ',

              }}
            >
              Add Lease
            </Button>
          </div>
        ),
      }}
      options={{
        headerStyle: {
          backgroundColor: '#1976d2',
          color: '#FFF',
          textAlign: 'left',
          position: 'sticky',
          top: 0,
        },
        maxBodyHeight: '85vh',
        selection: false,
        exportButton: true,
        // exportCsv: handleExportCsv,
        paging: false, // Render all rows
        searchFieldStyle: {
          border: 'none',
          paddingTop: '4px',
          paddingBottom: '4px',
          paddingLeft: '8px',
          paddingRight: '8px',
          borderRadius: '4px',
          backgroundColor: '#fff',
          color: '#000',
        },
        searchFieldAlignment: 'left',
        toolbarButtonAlignment: 'left',
        showTitle: false,
        actionsColumnIndex: 1,
      }}
    />
    </div>
  );
};

export default OtherLeaseTable;